import { useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useCreateNote } from "@/hooks/useLeadNotes";

type Props = { leadId: string };

export function NoteInput({ leadId }: Props): React.JSX.Element {
  const [content, setContent] = useState("");
  const { mutate, isPending, error } = useCreateNote(leadId);

  function submit(): void {
    const trimmed = content.trim();
    if (!trimmed) return;
    mutate(trimmed, {
      onSuccess: () => setContent(""),
    });
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLTextAreaElement>): void {
    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      submit();
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <textarea
        rows={2}
        placeholder="Escribe una nota… (⌘↵ para guardar)"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isPending}
        className={cn(
          "w-full resize-none rounded-md border border-ink-300 bg-surface px-3 py-2",
          "text-sm text-ink-900 placeholder:text-ink-300",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-dk",
          "disabled:opacity-50"
        )}
      />
      {error && (
        <p className="text-xs text-red-500">{(error as Error).message}</p>
      )}
      <div className="flex justify-end">
        <Button
          size="sm"
          onClick={submit}
          disabled={isPending || !content.trim()}
        >
          {isPending ? "Guardando…" : "Guardar nota"}
        </Button>
      </div>
    </div>
  );
}
